export default __webpack_public_path__ + "assets/default-picture.f3ce920a3d8ebbf91e6e3cb1c973334e.png";